import { useApp } from 'contexts/app';
import { useViewport } from 'contexts/viewport';
import Desktop from 'pages/InstructorViewSubmission/desktop';
import Mobile from 'pages/InstructorViewSubmission/mobile';
import { PageContext } from 'pages/InstructorViewSubmission/PageProvider';
import Tablet from 'pages/InstructorViewSubmission/tablet';
import { useContext } from 'react';
import { Loading } from 'shell/components';

const PageLayout = () => {
    const { isLoading } = useApp();
    const { device } = useViewport();

    const props = useContext(PageContext);

    const { currentAssignment, currentSubmission } = props;

    const renderResponsiveLayout = (device) => {
        return {
            mobile: <Mobile {...props} />,
            tablet: <Tablet {...props} />,
            desktop: <Desktop {...props} />,
        }[device];
    };

    return isLoading || !currentAssignment || !currentSubmission ? <Loading /> : <>{renderResponsiveLayout(device)}</>;
};

export default PageLayout;
